import { Box, Stack } from "@chakra-ui/react";
import React from "react";
import PaginationSizeSelect from "../../utils/Loader/PaginationSizeSelect";
import Paginator from "../../utils/Loader/Paginator";
import useVoicesHook from "./useVoicesHook";
import VoicesFilter from "./VoicesFilter";
import VoicesTable from "./VoicesTable";

const AvailableVoices = () => {
  const {
    page,
    types,
    pages,
    loading,
    paginationSize,
    languages,
    providersDetails,
    queries,
    availableVoices,
    setQueries,
    getProvicerIcon,
    setPaginationSize,
    getVoiceOwnerIcon,
    previewDefaultAudio,
    specificProviderList,
    getAllSpecificProvider,
    getSubHeadingDescriptionLabel,
    setPage,
  } = useVoicesHook({ tab: "availableVoices" });

  const columns = [
    "Provider",
    "Language",
    "Name",
    "Description",
    "Owner Type",
    "Preview",
  ];

  const tableData = availableVoices;

  return (
    <>
      <Stack h={"95%"} w={"100%"} spacing={2}>
        <VoicesFilter
          tab="availableVoices"
          types={types}
          queries={queries}
          languages={languages}
          providersDetails={providersDetails}
          specificProviderList={specificProviderList}
          setQueries={setQueries}
          getAllSpecificProvider={getAllSpecificProvider}
        />

        <Box h={"100%"} overflowY={"auto"}>
          <VoicesTable
            data={tableData}
            columns={columns}
            queries={queries}
            loading={loading}
            getVoiceOwnerIcon={getVoiceOwnerIcon}
            previewDefaultAudio={previewDefaultAudio}
            providersDetails={providersDetails}
            setQueries={setQueries}
            getProvicerIcon={getProvicerIcon}
            getSubHeadingDescriptionLabel={getSubHeadingDescriptionLabel}
          />
        </Box>
      </Stack>

      <Box display="flex" gap={2} justifyContent="end">
        <PaginationSizeSelect
          paginationSize={paginationSize}
          tableLength={availableVoices?.length}
          setPaginationSize={setPaginationSize}
        />
        <Paginator
          colorScheme={"blue"}
          page={page}
          pages={pages}
          onChangePage={setPage}
        />
      </Box>
    </>
  );
};

export default AvailableVoices;
